// var host_win = "https://17db-20-197-9-96.ngrok-free.app";
// var host_mac = "https://17db-20-197-9-96.ngrok-free.app";
// var host_win = "https://fuzzyapi.finkraftai.com";
var host_win = "http://localhost:5000"
// var host_mac = "https://fuzzyapi.finkraftai.com";
var host_mac = "http://localhost:5000"
var device = "mac";
export var host = "";

if ((device = "mac")) {
  host = host_mac;
} else {
  host = host_win;
}
